import { PREVIEW_INITIAL } from "./general";

export const defaultMaleVoice = "en-US-BrandonNeural";
export const defaultFemaleVoice = "en-US-AmberNeural";

export const INITIAL_SLIDE_STATE = {
  thumbnail: PREVIEW_INITIAL,
  objects: [],
  originalScript: "",
  script: "",
  voice: defaultMaleVoice,
  music: "",
  language: "",
  voiceFile: "",
  generatedVoice: "",
  is_user_audio: false,
  elevenlabs_voice: null,
  isFaceless: false,
  subtitle: "",
  user_audio_volume: 1,
};
